module.exports = __webpack_public_path__ + "static/img/nodata.c6df961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/nodata.png
// module id = 4oz5
// module chunks = 32